import { DEFAULT_COLOR } from '../../constants';
import { SettingsFormData } from '../../types';

export interface ImageItem {
    content: string;
    key: string;
    value: string;
    renderFunction: () => JSX.Element;
}

export const getInitialFormValues = (data: any, showLoginBtn = true): SettingsFormData => {
    const {
        theme: {
            general = {},
            header = {},
            sidebar = {},
            contentCard = {},
            contentPage = {},
            footer = {},
            loginPopup = {}
        } = {},
        settings: {
            seo = {}
        } = {},
        settings = {},
    } = data;

    return {
        generalBackgroundColor: general.backgroundColor?.colorOne || DEFAULT_COLOR,
        generalSectionTextColor: general.sectionTextColor || DEFAULT_COLOR,
        generalFavicon: general.portalFavIcon || '',
        homePageBanner: general.homePageBanner || '',
        headerLogo: header.logo || '',
        headerBackgroundColor: header.backgroundColor?.colorOne,
        headerTextColor: header.textColor || DEFAULT_COLOR,
        headerIsPlayerNameShown: header.showPlayerName,
        headerIsPlayerBalanceShown: header.showPlayerBalance,
        headerIsLoginBtnShown: showLoginBtn ? header.showLogin : true,
        headerIsLanguageSwitcherShown: header.showTranslations,
        settings: {
            seo: {
                portalTitle: seo.portalTitle || '',
                portalDescription: seo.portalDescription || '',
                portalKeywords: seo.portalKeywords ?? [],
                portalOGImage: seo.portalOGImage || '',
            },
            addToHomeScreen: {
                active: settings?.addToHomeScreen?.active || false,
                borderColor: settings?.addToHomeScreen?.borderColor?.colorOne || '#CB1010',
                backgroundColor: settings?.addToHomeScreen?.backgroundColor?.colorOne || '#CB1010',
                buttonImage: settings?.addToHomeScreen?.buttonImage || '',
                iconImage: settings?.addToHomeScreen?.iconImage || '',
                shortcutName: settings?.addToHomeScreen?.shortcutName || '',
            },
        },
        sidebarBackgroundColor: sidebar.backgroundColor?.colorOne || DEFAULT_COLOR,
        sidebarTextColor: sidebar.textColor || DEFAULT_COLOR,
        sidebarHoverColor: sidebar.tabHoverColor?.colorOne || DEFAULT_COLOR,
        selectedTabColor: sidebar.selectedTabColor || DEFAULT_COLOR,
        contentCardBackgroundColor: contentCard.backgroundColor?.colorOne || DEFAULT_COLOR,
        contentCardTextColor: contentCard.textColor || DEFAULT_COLOR,
        contentCardButtonColor: contentCard.buttonColor?.colorOne || DEFAULT_COLOR,
        contentPageTextColor: contentPage.textColor || DEFAULT_COLOR,
        footerBackgroundColor: footer.backgroundColor?.colorOne || DEFAULT_COLOR,
        footerTextColor: footer.textColor || DEFAULT_COLOR,
        footerPrivacyLink: footer.privacyPolicyUrl || '',
        footerTermsConditionsLink: footer.termsOfServiceUrl || '',
        footerSupportLink: footer.supportUrl || '',
        loginPopupText: loginPopup.text || '',
        loginPopupFont: loginPopup.font || 'Roboto',
        loginPopupFontSize: loginPopup.fontSize || 12,
        loginPopupFontColor: loginPopup.fontColor || DEFAULT_COLOR,
        loginPopupFontWeight: loginPopup.fontWeight || 'regular',
        loginPopupBackgroundImageMobile: loginPopup.backgroundImageMobile || '',
        loginPopupBackgroundImageDesktop: loginPopup.backgroundImageDesktop || '',
        loginPopupLogo: loginPopup.logo || '',
        loginPopupLogoSize: loginPopup.logoSize || '',
        loginPopupConsentSection: {
            htmlText: loginPopup.consentSection?.htmlText || '',
            consentRequired: loginPopup.consentSection?.consentRequired || false
        },
    };
};